<template>
  <div>
    <div class="d-flex typography">
      <div class="container">
        <div class="card rounded-0  bg-white px-4 pt-3 pb-6">
          <div class="card-body px-0 pt-4 pb-0">
            <div class="container">
              <div class="row">
                <div class="col-6">
                  <div class="form-login mb-4">
                    <form>
                    
                      <div class="form-group mb-2">
                        <label for="businessCategoryId" >Business Category</label>
                        <select class="form-control font-size-lg  form-control-lg bg-transparent py-0" :class="{ 'is-invalid': errors.businessCategoryId }"
                          v-model="details.businessCategoryId" :disabled="isLoading ? '' : isLoading">
                          <option value="">All Categories</option>

                          <option v-for="item in businessCategories" :key="item.id" :value="item.id">
                            {{ item.name }}
                          </option>

                        </select>

                        <div class="invalid-feedback" v-if="errors.businessCategoryId">
                          {{ errors.businessCategoryId[0] }}
                        </div>
                      </div>

                      <div class="form-group mb-2">
                        <label for="businessName" >Business Name</label>
                        <input id="businessName" type="text" class="form-control font-size-lg  form-control-lg bg-transparent"
                          :class="{ 'is-invalid': errors.businessName }" v-model="details.businessName"
                          placeholder="Enter business name" :disabled="isLoading ? '' : isLoading" />

                        <div class="invalid-feedback" v-if="errors.businessName">
                          {{ errors.businessName[0] }}
                        </div>
                      </div>

                      <div class="form-group mb-3">
                        <label for="businessEmail" >Business email</label>
                        <input id="businessEmail" type="text" class="form-control font-size-lg  form-control-lg bg-transparent"
                          :class="{ 'is-invalid': errors.businessEmail }" v-model="details.businessEmail"
                          placeholder="Enter business email" :disabled="isLoading ? '' : isLoading" />

                        <div class="invalid-feedback" v-if="errors.businessEmail">
                          {{ errors.businessEmail[0] }}
                        </div>
                      </div>
                      <div class="form-group mb-2">
                        <label for="website" >Website</label>
                        <input id="website" type="text" class="form-control font-size-lg  form-control-lg bg-transparent" :class="{ 'is-invalid': errors.website }"
                          v-model="details.website" placeholder="ex: https://plectrumbusiness.com"
                          :disabled="isLoading ? '' : isLoading" />

                        <div class="invalid-feedback" v-if="errors.website">
                          {{ errors.website[0] }}
                        </div>
                      </div>
                      <div class="form-group mb-2">
                        <label for="description" >Description</label>
                        <textarea id="description" class="form-control font-size-lg  form-control-lg bg-transparent" :class="{ 'is-invalid': errors.description }"
                          v-model="details.description" height="300px" placeholder="Enter description"
                          :disabled="isLoading ? '' : isLoading"></textarea>

                        <div class="invalid-feedback" v-if="errors.description">
                          {{ errors.description[0] }}
                        </div>
                      </div>

                      

                      <div class="form-group mt-6" v-if="errors.message">
                        <MessageErrorFadeOut v-bind:message="errors.message" v-bind:show="errors.message?true:false" />
                      </div>
                      <button type="button" @click="createBusiness" :disabled="isLoading ? '' : isLoading"
                        class="btn btn-primary btn-block btn-lg mb-7 font-weight-bold  font-size-md rounded-md">
                        <span v-if="!isLoading"> Next </span>
                        <span v-if="isLoading">
                          <i class="fas fa-circle-notch fa-spin"></i>
                          Creating...</span>
                      </button>
                    </form>
                  </div>
                </div>
                <div class="col-6">
                  <div class="profile media d-flex align-items-center flex-wrap">
                  <div class="container">

                        <div class="card image-box-style-card box-shadow-hover p-1 mb-3" style="border:1px solid #253644 !important">
                        <img class="p-1" v-bind:src="imagePreview" />
                      </div>
                      <div class="pl-2 upload-btn-wrapper col-12">

                          <button class="btn btn-primary px-4 font-size-md text-center align-items-center" :disabled="this.details.logo && isLoading ? '' : this.details.logo && isLoading">

                            <span v-if="!(this.details.logo && isLoading)"> Choose Logo </span>
                            <span v-if="this.details.logo && isLoading">
                              <i class="fas fa-circle-notch fa-spin"></i>
                              Uploading...</span>
                          </button>
                          <input type="file" id="logo" @change="onFileChange" :disabled="this.details.logo && isLoading ? '' : this.details.logo && isLoading" />
                        </div>
                    </div>
                  <div class="m-4">
                     <div class="text-danger" v-if="errors.logo">
                      
                            {{errors.logo[0]}}
        
                            </div>
                   

                         <div class="text-danger" v-if="uploadError">
                      
                            {{uploadError}}
        
                            </div>
                   </div>

                  </div>
                  <div class="media-body d-flex flex-wrap"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import {
    mapGetters,
    mapActions
  } from "vuex";
  import MessageErrorFadeOut from "../Common/Message/MessageErrorFadeOut"
  export default {
    name: "CreateMyBusiness",

    data: function () {
      return {

        imagePreview: '/images/upload.gif',
        showPreview: false,
        uploadError:'',
        details: {
          businessName: '',
          businessEmail: '',
          description: '',
          website: '',
          logo: null,
          businessCategoryId: null

        },
      };
    },
     components: {
      MessageErrorFadeOut
    },
    computed: {
        ...mapGetters("auth", ["user"]),
      ...mapGetters("business", ['businessCategories','currentBusiness']),
      ...mapGetters(["errors", "isLoading", "isSuccess"]),
    },

    mounted() {
      this.getBusinessCategories();

      this.$store.commit("setErrors", {});
      this.$store.commit("setIsLoading", false);
      this.$store.commit("setIsSuccess", false);

    },

    methods: {
      ...mapActions("business", ["sendBusinessRequest", "getBusinessCategories"]),
    
      createBusiness: function () {
        let formData = new FormData();
        formData.append("businessName", this.details.businessName);
        formData.append("businessEmail", this.details.businessEmail);
        formData.append("description", this.details.description);
        formData.append("website", this.details.website);
        formData.append("businessCategoryId", this.details.businessCategoryId);
        formData.append("isHeadQuarter", 1);
        
        formData.append("logo", this.details.logo);

        this.sendBusinessRequest(formData).then(() => {
          if (this.isSuccess) {
              this.$notify({
                  group: "app",
                  type: "success",
                  title: "Done",
                  text: "Business created successfully",
                  duration: 10000,
                  speed: 1000,
          });
            this.user.hasBusiness=true;
            this.user.activeBusiness=this.currentBusiness;
            this.$router.push({name: "CreateBussinessAddressStepper",
               params: { partnerId: this.currentBusiness.partnerId } }).catch(() => {})

          }
        });
      },
      onFileChange(event) {
        this.uploadError='';
        /*
    Set the local file variable to what the user has selected.
    */
        this.details.logo = event.target.files[0];

        /*
    Initialize a File Reader object
    */
        let reader = new FileReader();

        /*
    Add an event listener to the reader that when the file
    has been loaded, we flag the show preview as true and set the
    image to be what was read from the reader.
    */
        reader.addEventListener(
          "load",
          function () {
            this.showPreview = true;
            this.imagePreview = reader.result;
          }.bind(this),
          false
        );

        /*
    Check to see if the file is not empty.
    */
        if (this.details.logo) {
          if (/\.(jpe?g|png|gif)$/i.test(this.details.logo.name)) {
          
            reader.readAsDataURL(this.details.logo);
          }else{
            this.uploadError="Only (jpg,jpeg,png,gif) image format allowed!";
          }
        }
      },
    },
  };
</script>